import { useCallback, useEffect } from 'react'
import { Platform } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { SDKQueryClient, SDKQueryClientPersister, useIsAuthed, useSDK } from '@vatom/sdk/react'
import { LoaderView } from '@vatom/wombo'
import { observer } from 'mobx-react-lite'

import { useStore } from '../../models'
import { AppRoutes } from '../../navigators'

export const LogoutCallback = observer(() => {
  const focused = useIsFocused()
  const isAuthed = useIsAuthed()
  const navigation = useNavigation()
  const sdk = useSDK()
  const store = useStore()

  const claimOrConnect = useCallback(async () => {
    try {
      const claimDetails = await AsyncStorage.getItem('CLAIM_DETAILS')
      if (claimDetails) {
        const parsedClaimDetails = JSON.parse(claimDetails)
        const claimId = parsedClaimDetails.claimId
        delete parsedClaimDetails.claimId
        AsyncStorage.removeItem('CLAIM_DETAILS')
        return window.location.replace(
          `/claim/${claimId}?${Object.keys(parsedClaimDetails)
            .map(key => key + '=' + encodeURIComponent(parsedClaimDetails[key]))
            .join('&')}`
        )
      }
    } catch (error) {
      //
    } finally {
      navigation.navigate(AppRoutes.connect)
    }
  }, [navigation])

  useEffect(() => {
    if (Platform.OS === 'web' && window.location.href.includes('logout-callback')) {
      console.log('[SessionStore] clear LogoutCallback')
      // Log out of the user store
      store.linking.clearLinkingUrl()
      sdk.service.setToken(undefined)
      sdk.dataPool.sessionStore.clear()
      SDKQueryClient.clear()
      SDKQueryClientPersister.removeClient()
      sdk.dataPool.user.logout()
      claimOrConnect()
    }
  }, [claimOrConnect, sdk.dataPool.sessionStore, sdk.dataPool.user, sdk.service, store.linking])

  useEffect(() => {
    if (!isAuthed) {
      claimOrConnect()
    }
  }, [claimOrConnect, isAuthed, navigation])

  if (!focused) {
    return null
  }

  return <LoaderView />
})

export default LogoutCallback
